import { useGlobalContext } from '~/context/GlobalContext';
import { IChatUser } from '~/types/common';

export const usePrivateMessageClick = () => {
  const { context, setContext } = useGlobalContext();

  const handlePrivateMessageClick = (
    targetUser: IChatUser, 
    currentUserId: string, 
    onActionComplete?: () => void
  ) => {
    if (targetUser.id === currentUserId) return;
    
    // Wywołaj callback czyszczący UI (np. zamknięcie dropdownu), jeśli został podany
    if (onActionComplete) {
      onActionComplete();
    }

    const storedData = window.sessionStorage.getItem('user');
    const data = storedData ? JSON.parse(storedData) : null;
    if (!data) return;

    // Sprawdzamy, czy mamy już z tym użytkownikiem otwarty prywatny pokój
    const existingRoom = context.rooms.find(
      r => r.private && r.users?.some(u => u.id === data.id) && r.users?.some(u => u.id === targetUser.id)
    );

    if (existingRoom) {
      // Jeśli tak, po prostu się na niego przełączamy
      setContext(prev => ({
        ...prev,
        activeSidebarId: '',
        room: existingRoom,
        activeRoomId: existingRoom.id,
      }));
      return;
    }

    // Jeśli nie, wysyłamy sygnał do serwera, by utworzyć nowy pokój
    window.dispatchEvent(new CustomEvent('privateJoin', {
      bubbles: true,
      detail: { type: 'privateJoin', id: targetUser.id },
    }));
  };

  return handlePrivateMessageClick;
};